import type { ComponentType } from 'react';

import { AboutPage } from './AboutPage';
import { DashboardPage } from './DashboardPage';
import { LogoutPage } from './LogoutPage';

export interface Page {
  path: string;
  title: string;
  component: ComponentType;
}

export type PageName = 'dashboard' | 'logout' | 'about';

const getRoutes = () => {
  const routes: Record<PageName, Page> = {
    dashboard: {
      path: '/',
      component: DashboardPage,
      title: 'Dashboard',
    },
    about: {
      path: '/about',
      component: AboutPage,
      title: 'About',
    },
    logout: {
      path: '/logout',
      component: LogoutPage,
      title: 'Logout',
    },
  };

  return routes;
};

export const routes: Record<PageName, Page> = getRoutes();
